import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  LOAD_CATALOG,
  CLEAR_CATALOG,
  loadIncidents
} from 'src/store/actions/catalogActions';
import { selectCatalogList } from 'src/store/selectors/catalogSelectors';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import IncidentTable from './IncidentTable';

// eslint-disable-next-line react/prop-types
const InicidentList = ({ handleOpenEdit, handleDelete }) => {
  const dispatch = useDispatch();
  const incidents = useSelector(selectCatalogList);
  const loading = useSelector(isLoadingSelector([LOAD_CATALOG.action]));

  useEffect(() => {
    dispatch(loadIncidents());
    return () => dispatch({ type: CLEAR_CATALOG });
  }, []); // not add dependency

  return (
    <IncidentTable
      incidents={incidents}
      loading={loading}
      handleOpenEdit={handleOpenEdit}
      handleDelete={handleDelete}
    />
  );
};

export default InicidentList;
